module.exports = __webpack_public_path__ + "static/media/online_friends.2c1a0c6d.png";